import { observable, action, computed, toJS, makeObservable } from 'mobx';

export default class StoreBoxes {
    initialState = observable({
        boxes: {}
    });

    boxItemState = {
        targetId: null,
        isBox: true,
        data: {
            counts: {
                total: {},
                unknown: {},
                suspicious: {},
                compromised: {}
            }
        }
    };

    constructor() {
        makeObservable(this, {
            boxState: computed,
            setBoxes: action
        });
    }

    //Computed values can be used to derive information from other observables.
    get boxState() {
        return toJS(this.initialState);
    }

    //An action is any piece of code that modifies the state. The action annotation should only be used on functions that intend to modify the state
    setBoxes({ items }) {
        let { boxes } = this.updateBoxes(items, this.boxItemState, this.boxState);
        this.initialState.boxes = boxes;
    }

    findBoxDetailByWindow(days) {
        let boxWindow = this.getBoxWindow(days);
        const { boxes } = this.boxState;

        for (let i in boxes) {
            if (boxes[i].timeWindow && boxes[i].timeWindow[boxWindow.key] === parseInt(boxWindow.value)) {
                return boxes[i];
            }
        }

        return this.boxItemState;
    }

    getBoxWindow = (boxWindow) => {
        let [value, key] = boxWindow.split(' ');

        if (!value || !key) {
            throw new Error('Invalid format to get box window');
        }

        return { key, value };
    };

    setBoxItem(state, item) {
        return {
            ...state,
            ...item
        };
    }

    updateBoxes(items, state, boxState) {
        return {
            ...boxState,
            boxes: {
                ...boxState.boxes,
                ...items.reduce((obj, item, index) => {
                    obj[index] = this.setBoxItem(state, item);
                    return obj;
                }, {})
            }
        };
    }
}
